$('.modal .icon--close').click(function (e) {
	e.preventDefault()
	$(this).parent('.modal').fadeOut(200)
})

$('.show-modal').click(function (e) {
	e.preventDefault()
	$()
})

$('.show-modal').on('click', function (e) {
	e.preventDefault()
	var modalTarget = $(this).data('target')

	if ($('.' + modalTarget).length) {
		$('.' + modalTarget).fadeIn(200)
	}
})
